<template>
  <div class="modal fade show" style="display: block">
    <div class="modal-dialog modal-dialog-centered" style="min-width: 600px">
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <h5 class="modal-title">{{ formTitle }}</h5>
          <button
            type="button"
            class="btn-close"
            @click="handleClose()"
          ></button>
        </div>
        <form>
          <div class="modal-body">
            <div class="row gy-4 mb-3">
              <div class="col">
                <label for="start-field" class="form-label">
                  <span class="text-danger">*</span>开始时间</label
                >
                <flat-pickr
                  v-model="form.repair_at"
                  :config="dateConfig"
                  class="form-control flatpickr-input"
                  :class="{
                    'is-invalid': submitted && v$.form.repair_at.$error,
                  }"
                ></flat-pickr>
                <div
                  v-if="submitted && v$.form.repair_at.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.form.repair_at.required.$message">{{
                    v$.form.repair_at.required.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="start-field" class="form-label"
                  ><span class="text-danger">*</span>设备</label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="form.equipment_snapshot"
                  :class="{
                    'is-invalid':
                      submitted && v$.form.equipment_snapshot.$error,
                  }"
                  required
                  disabled
                />
                <div
                  v-if="submitted && v$.form.equipment_snapshot.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.form.equipment_snapshot.required.$message">{{
                    v$.form.equipment_snapshot.required.$message
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col d-inline-flex align-items-center">
                <span> 导致产线停产 </span>
                <input
                  type="checkbox"
                  class="form-check-input ms-1 my-0"
                  :checked="form.properties.suspendedCheck"
                  @click="
                    form.properties.suspendedCheck =
                      !form.properties.suspendedCheck
                  "
                />
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col" v-if="form.properties.suspendedCheck">
                <div class="d-flex align-items-center w-100">
                  <span>停产时长</span>
                  <div class="d-flex flex-1 ms-5">
                    <div class="input-group ms-1">
                      <Multiselect
                        v-model="form.properties.downTime[0]"
                        :close-on-select="true"
                        :searchable="true"
                        :canClear="false"
                        :options="daysList"
                        class="form-control"
                      />
                      <span class="input-group-text">天</span>
                    </div>
                    <div class="input-group ms-1">
                      <Multiselect
                        v-model="form.properties.downTime[1]"
                        :close-on-select="true"
                        :searchable="true"
                        :canClear="false"
                        :options="hoursList"
                        class="form-control"
                      />
                      <span class="input-group-text">时</span>
                    </div>
                    <div class="input-group ms-1">
                      <Multiselect
                        v-model="form.properties.downTime[2]"
                        :close-on-select="true"
                        :searchable="true"
                        :canClear="false"
                        :options="minList"
                        class="form-control"
                      />
                      <span class="input-group-text">分</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="comment-field" class="form-label">故障描述</label>
                <textarea
                  rows="3"
                  class="form-control"
                  v-model="form.description"
                />
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="comment-field" class="form-label">解决方案</label>
                <textarea
                  rows="3"
                  class="form-control"
                  v-model="form.properties.solution"
                />
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="comment-field" class="form-label">资料</label>
                <DropZone
                  @drop.prevent="drop"
                  @change="selectedFile"
                  style="min-height: 220px"
                  limit="50M"
                />
                <ul
                  class="list-unstyled mb-0"
                  id="dropzone-preview"
                  v-if="form.attachments"
                >
                  <div
                    class="border rounded"
                    v-for="(file, index) of form.attachments"
                    :key="index"
                  >
                    <div class="d-flex p-2">
                      <div class="flex-grow-1">
                        <div class="pt-1">
                          <h5 class="fs-14 mb-1">
                            <a
                              :href="file.url"
                              :download="file.url"
                              class="text-break"
                            >
                              {{ filterName(file.objectName) }}
                            </a>
                          </h5>
                          <p class="fs-13 text-muted mb-0">
                            <strong>{{ file.size / 1024 }}</strong> KB
                          </p>
                        </div>
                      </div>
                      <div class="flex-shrink-0 ms-3">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="deleteFile(index)"
                        >
                          删除
                        </button>
                      </div>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="comment-field" class="form-label">操作员</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.operator"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" @click="handleClose">
                取消
              </button>
              <button
                type="button"
                class="btn btn-primary"
                id="add-btn"
                @click="handleSubmit"
              >
                确认
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>
<script>
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Multiselect from "@vueform/multiselect";

import "@vueform/multiselect/themes/default.css";
import "@/default.scss";
import _ from "loadsh";
import DropZone from "@/components/widgets/dropZone";
import axios from "axios";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import {
  getInstancesDetailId,
  createRepairTasks,
  editRepairTasks,
  getUploadFileSign,
  getUploadFileDetail,
} from "@/service/index.js";
import { filterDurationTime } from "@/utils/common.js";
import {imageCompress} from '@/utils/common.js'
import Swal from "sweetalert2";
export default {
  emits: ["update:isShowAddForm", "handleAlert", "handleGetRepairRecords"],
  props: {
    date: Object,
    isShowAddForm: Boolean,
    formType: {
      type: String,
      default: "add",
    },
    singleData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    form: {
      repair_at: {
        required: helpers.withMessage("开始时间为必填项", required),
      },
      equipment_snapshot: {
        required: helpers.withMessage("设备为必填项", required),
      },
    },
  },
  components: {
    Multiselect,
    DropZone,
  },
  watch: {
    singleData: {
      handler(newVal) {
        this.form = _.cloneDeep(newVal);
      },
      deep: true,
      immediate: true,
    },
    "form.repair_at": {
      handler(newVal) {
        this.endDateConfig.minDate = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    formTitle() {
      return this.formType === "edit" ? "编辑设备维修任务" : "新增设备维修任务";
    },
    daysList() {
      let list = this.filterArr(31);
      if (!list.includes(this.form.properties.downTime[0])) {
        list.push(this.form.properties.downTime[0]);
      }
      return list;
    },
  },
  mounted() {},
  created() {
    if (this.formType == "add") {
      this.handleGetEquipList();
    } else {
      this.handleGetEquipList(this.singleData.equipment_id);
    }
  },
  data() {
    return {
      form: {},
      dateConfig: {
        altFormat: "Y-m-d",
        altInput: false,
        dateFormat: "Y-m-d",
      },
      endDateConfig: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      equipmentList: [],
      submitted: false,
      downTimeTip: "",
      minList: this.filterArr(60),
      hoursList: this.filterArr(24),
      fileMaxSize: 1024 * 1024 * 50,
      fileType: [
        ".ppt",
        ".pptx",
        ".pdf",
        ".xlsx",
        ".xls",
        ".docx",
        ".doc",
        ".PNG",
        ".png",
        ".JPEG",
        ".jpeg",
        ".MP4",
        ".mp4",
        ".MOV",
        ".mov",
      ],
    };
  },

  methods: {
    filterDurationTime,
    filterArr(num) {
      var arr = new Array();
      for (var i = 0; i <= num; i++) {
        arr.push(i);
      }
      return arr;
    },
    handleClose() {
      this.$emit("update:isShowAddForm", false);
    },
    handleSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) return;
      if (!this.form.repair_at.includes(":")) {
        this.form.repair_at =
          this.form.repair_at + " " + moment().format("HH:mm:ss");
      }
      if (this.form.properties.suspendedCheck) {
        let check = this.form.properties.downTime.every((t) => {
          return t != null && !isNaN(t);
        });
        if (!check) {
          this.$emit("handleAlert", "danger", "停机时间必须是数字");
          return;
        }
        if (this.form.properties.downTime.join() == [0, 0, 0].join()) {
          this.$emit("handleAlert", "danger", "停机时间为必填项且不能为0");
          return;
        }
      } else {
        this.form.properties.downTime = [0, 0, 0];
      }

      if (this.formType === "edit") {
        if (this.form.end_date && !this.form.end_date.includes(":")) {
          this.form.end_date =
            this.form.end_date + " " + moment().format("HH:mm:ss");
        }
        let params = this.form;
        params.properties = JSON.stringify(this.form.properties);
        let id = this.form.id;
        editRepairTasks(id, params)
          .then((res) => {
            if (res && _.get(res, ["meta", "code"]) == 200 && res.payload) {
              this.$emit(
                "handleAlert",
                "success",
                "编辑任务成功!",
                "ri-check-double-line",
                1000
              );
              this.$emit("handleGetRepairRecords", this.date);
              this.handleClose();
            }
          })
          .catch((err) => {
            this.$emit(
              "handleAlert",
              "danger",
              err.message || "请求失败，请重试!"
            );
          });
      } else {
        let params = {
          ...this.form,
          properties: JSON.stringify(this.form.properties),
        };
        createRepairTasks(params)
          .then((res) => {
            if (res && _.get(res, ["meta", "code"]) == 200 && res.payload) {
              this.$emit(
                "handleAlert",
                "success",
                "创建成功!",
                "ri-check-double-line",
                1000
              );
              this.$emit("handleGetRepairRecords", this.date);
              this.handleClose();
            }
          })
          .catch((err) => {
            this.$emit(
              "handleAlert",
              "danger",
              err.message || "请求失败，请重试!"
            );
          });
      }
    },

    handleGetEquipList(id) {
      let params = {
        id: id || this.$route.query.equip_id,
      };
      getInstancesDetailId(params)
        .then((res) => {
          if (res && _.get(res, ["meta", "code"]) == 200 && res.payload) {
            this.form.equipment_snapshot = res.payload.name;
            this.form.equipment_id = res.payload.id;
            let nameList = [];
            res.payload.repairs.forEach((repair) => {
              nameList.push(...repair.names);
            });
            this.equipmentList = nameList;
          }
        })
        .catch((err) => {
          this.$emit(
            "handleAlert",
            "danger",
            err.message || "请求失败，请重试"
          );
        });
    },

    async selectedFile() {
      let dropzoneFile = document.querySelector(".dropzoneFile").files[0];
      if (!dropzoneFile) return;
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (!this.fileType.includes(suffix)) {
        this.$emit("handleAlert", "danger", "文件类型不符合!");
        document.querySelector(".dropzoneFile").value = "";
        return;
      }
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit("handleAlert", "danger", "文件大小不能超过50M!");
        document.querySelector(".dropzoneFile").value = "";
        return;
      }

      if(/\.(png|jpeg|jpg)$/.test(suffix)){
        let file = await imageCompress(dropzoneFile)
        this.uploadFileSign(file);
      }else{
        this.uploadFileSign(dropzoneFile);
      }

    },
    uploadFileSign(file) {
      Swal.fire({ title: "上传中...", showConfirmButton: false });
      Swal.showLoading();
      let filename = file.name;
      let objectName = `events/${uuidv4()}/${filename}`;
      let params = {
        object: objectName,
        method: "upload",
      };
      getUploadFileSign(params).then((res) => {
        if (res && res.payload) {
          axios
            .put(res.payload.signedUrl, file)
            .then(() => {
              let params = {
                object: objectName,
              };
              Swal.close();
              this.$emit(
                "handleAlert",
                "success",
                "上传成功!",
                "ri-check-double-line"
              );
              getUploadFileDetail(params).then((detail) => {
                if (detail && detail.payload) {
                  this.form.attachments = this.form.attachments
                    ? this.form.attachments
                    : [];
                  this.form.attachments.push(detail.payload);
                  document.getElementById("dropzoneFile").value = "";
                }
              });
            })
            .catch((err) => {
              Swal.close();
              this.$emit(
                "handleAlert",
                "danger",
                err.message || "请求失败，请重试!"
              );
            });
        }
      });
    },
    async drop(e) {
      let dropzoneFile = e.dataTransfer.files[0];
      if (!dropzoneFile) return;
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (!this.fileType.includes(suffix)) {
        this.$emit("handleAlert", "danger", "文件类型不符合!");
        document.querySelector(".dropzoneFile").value = "";
        return;
      }
      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit("handleAlert", "danger", "文件大小不能超过50M!");
        document.querySelector(".dropzoneFile").value = "";
        return;
      }
      if(/\.(png|jpeg|jpg)$/.test(suffix)){
        let file = await imageCompress(dropzoneFile)
        this.uploadFileSign(file);
      }else{
        this.uploadFileSign(dropzoneFile);
      }
    },
    deleteFile(i) {
      this.form.attachments.splice(i, 1);
    },
    filterName(name) {
      if (/^(device\/)/.test(name)) {
        return name.substring(44);
      } else if (/^(reports\/)/.test(name)) {
        return name.substring(45);
      } else if (/^(events\/)/.test(name)) {
        return name.substring(44);
      } else {
        return name;
      }
    },
  },
};
</script>
<style lang="scss">
.multiselect-wrapper {
  .multiselect-single-label-text {
    overflow: inherit !important;
  }
}
</style>
